enum Servers {
  stimSrv = "https://stim-srv.krista.ru/web~",
  espk = "https://espk.krista.ru/web~",
  hmao = "https://budgetsmeta.admhmao.ru/web~",
  local = "http://localhost:1317/web~",
}

export const baseUrl = window.location.port === "3000" ? Servers.stimSrv : window.location.origin + "/web~";
